import { cn } from "@/lib/utils";
import logo from "../../assets/logo.png";
import { useState } from "react";
import { useAuth } from "@/features/Auth";
import { Settings } from "lucide-react";
import { Dropdown, DropdownTrigger } from "@heroui/react";
import UserMenu from "../../components/UserMenu";

export default function Footer() {
  const [toggleDropdown, setToggleDropdown] = useState(false);

  const { user } = useAuth();
  const displayName = user?.name || user?.email || "Mon compte";

  return (
    <div
      className={cn(
        "sticky bottom-0 z-20",
        "bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/60",
      )}
    >
      {/* Make this relative so the dropdown positions correctly */}
      <div className="relative h-12 w-full flex items-center gap-2 px-2">
        {/* Left: user identity (no toggle here) */}
        <div
          className={cn("flex items-center gap-2 transition-all duration-300")}
        >
          <img alt="Quantilia" className="h-6 w-auto" src={logo} />
          <span className="truncate max-w-[160px] text-xs">{displayName}</span>
        </div>
        <Dropdown
          placement="top-end"
          isOpen={toggleDropdown}
          onOpenChange={setToggleDropdown}
        >
          <DropdownTrigger>
            <button
              type="button"
              aria-expanded={toggleDropdown}
              aria-label={
                toggleDropdown
                  ? "Fermer les paramètres"
                  : "Ouvrir les paramètres"
              }
              className={cn(
                "ml-auto inline-flex h-8 w-8 items-center justify-center rounded-full",
                "border border-slate-200 bg-white shadow-sm",
                "hover:bg-slate-50 active:bg-slate-100",
              )}
            >
              <Settings className="h-4 w-4 text-slate-900" />
            </button>
          </DropdownTrigger>
          <UserMenu onClose={() => setToggleDropdown(false)} />
        </Dropdown>
      </div>
    </div>
  );
}
